import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  // This corresponds to the "as" property where mounted in hcp/router.js
  const mountPoint = this.options.engineInfo.mountPoint;

  // Public search experience
  if (mountPoint === 'vagrant-public') {
    this.route('discover', function () {
      this.route('registry', {
        path: '/:registry_id'
      }, function () {
        this.route('box', {
          path: '/:box_id'
        }, function () {
          this.route('versions', function () {
            this.route('version', {
              path: '/:version_id'
            });
          });
        });
      });
    });
  }

  // Authenticated private experience
  if (mountPoint === 'vagrant') {
    this.route('registries', function () {
      this.route('index', {
        path: '/'
      });
      this.route('create');
      this.route('registry', {
        path: '/:registry_id'
      }, function () {
        this.route('boxes', function () {
          this.route('create');
          this.route('box', {
            path: '/:box_id'
          }, function () {
            this.route('edit');
            this.route('versions', function () {
              this.route('create');
              this.route('version', {
                path: '/:version_id'
              }, function () {
                this.route('edit');
                this.route('add-architecture');
                this.route('edit-architecture', {
                  path: 'provider/:provider_id/:architecture_type'
                });
              });
            });
          });
        });
      });
    });
    this.route('intro');
  }
});